var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.166672C8.27614 0.166672 8.5 0.390529 8.5 0.666672V15.3333C8.5 15.6095 8.27614 15.8333 8 15.8333C7.72386 15.8333 7.5 15.6095 7.5 15.3333V0.666672C7.5 0.390529 7.72386 0.166672 8 0.166672Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32986 3.66319C4.86122 3.13184 5.58189 2.83333 6.33333 2.83333H11.3333C11.6095 2.83333 11.8333 3.05719 11.8333 3.33333C11.8333 3.60947 11.6095 3.83333 11.3333 3.83333H6.33333C5.8471 3.83333 5.38079 4.02648 5.03697 4.3703C4.69315 4.71412 4.5 5.18043 4.5 5.66666C4.5 6.15289 4.69315 6.61921 5.03697 6.96302C5.38079 7.30684 5.8471 7.5 6.33333 7.5H9.66667C10.4181 7.5 11.1388 7.79851 11.6701 8.32986C12.2015 8.86121 12.5 9.58188 12.5 10.3333C12.5 11.0848 12.2015 11.8054 11.6701 12.3368C11.1388 12.8682 10.4181 13.1667 9.66667 13.1667H4C3.72386 13.1667 3.5 12.9428 3.5 12.6667C3.5 12.3905 3.72386 12.1667 4 12.1667H9.66667C10.1529 12.1667 10.6192 11.9735 10.963 11.6297C11.3068 11.2859 11.5 10.8196 11.5 10.3333C11.5 9.8471 11.3068 9.38078 10.963 9.03697C10.6192 8.69315 10.1529 8.5 9.66667 8.5H6.33333C5.58189 8.5 4.86122 8.20148 4.32986 7.67013C3.79851 7.13878 3.5 6.41811 3.5 5.66666C3.5 4.91521 3.79851 4.19455 4.32986 3.66319Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.9af033a2436e48a163949a05334025a6.svg";
export { ForwardRef as ReactComponent };